import Print from '../src/Print';
export default Print;
